import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/arrow-customize-builder-back.svg'
import _imports_1 from '@/assets/icons/arrow-customize-builder.svg'


const _hoisted_1 = { class: "steppy" }
const _hoisted_2 = { class: "steppy-item-counter" }
const _hoisted_3 = {
  key: 0,
  class: "current-step-text"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "next-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "button button-prev",
      onClick: $setup.onSelectPrev
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("img", {
        class: "reverse",
        src: _imports_0
      }, null, -1),
      _createElementVNode("span", { class: "back-text" }, "Back", -1)
    ]))]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.tabs, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["steppy-item", $setup.getStepItemClass(index)]),
        key: item
      }, [
        _createElementVNode("div", _hoisted_2, [
          ($setup.stepIndex > index)
            ? (_openBlock(), _createBlock($setup["CheckMark"], {
                key: 0,
                class: "icon-success"
              }))
            : _createCommentVNode("", true)
        ]),
        ($setup.stepIndex === index + 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(item), 1))
          : _createCommentVNode("", true)
      ], 2))
    }), 128)),
    _createElementVNode("button", {
      class: "button button-next",
      onClick: $setup.onSelectNext,
      disabled: !$setup.isNextStepEnabled
    }, [
      _createElementVNode("span", _hoisted_5, _toDisplayString($setup.nextStepTextButton), 1),
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        class: "next",
        src: _imports_1
      }, null, -1))
    ], 8, _hoisted_4)
  ]))
}